import periodIsValid from 'utils/pivot/plan/period/periodIsValid'

function getValidPeriodKey(plan: Plan, period?: string | number): string {
  const longestDurationKey = Object.keys(plan.durations)
    .sort((a, b) => {
      return a[Object.keys(a)[0]].policyDuration - b[Object.keys(b)[0]].policyDuration
    })
    .slice(-1)[0]
  return period !== undefined && periodIsValid(plan, period)
    ? period.toString()
    : longestDurationKey
}

export default getValidPeriodKey
